import { RunContextApp }          from "framework/RCApp"
import { ApiError }               from "framework/utility/ErrorUtils"
import { ResetPasswordResponse }  from "types/apis/authInterfaces"

export interface AuthApiResult<T = any> {
  data  ?: T
  error ?: ApiError
}

export const AuthApis = {

  forgotPassword : async (rc : RunContextApp,
                          email : string) : Promise<AuthApiResult> => {
    return rc.noAuthClient.forgotPassword(email)
  },

  resetPassword : async (rc : RunContextApp,
                         code : string,
                         password : string,
                         passwordConfirmation : string) : Promise<AuthApiResult<ResetPasswordResponse>> => {
    return rc.noAuthClient.resetPassword(code, password, passwordConfirmation)
  },

}
